export const VR_VERIFY_SUC = '1' // 审核通过
export const VR_VERIFY_ING = '2' // 审核中
export const VR_VERIFY_FAIL = '3' // 审核失败
export const VR_VERIFY_MAKING = '999' // 制作中

export const VR_BASIC_SETTING = 'INFO' // 基础设置
export const VR_VIEW_SETTING = 'VIEW' // 视角设置
export const VR_HOTSPOT_SETTING = 'HOTSPOT' // 热点设置
